/* eslint-disable */
import React from 'react'

// style
import './CheckboxV2.scss'

function CheckboxV2(props) {
  const {value, name, handleCheck, id, data, checked, className} = props;

  return (
      <div className={`${className} item-dropdown-filter check-radio-custom-v2 py-0`}>
        <input 
          className="checkbox-custom checkbox-effect checkbox-effect-1" type="checkbox" 
          onChange={(e) => handleCheck(e, data)} 
          value={value} 
          id={id}
          checked={checked}
          // defaultChecked={defaultCheckboxValue(item.name)} 
          name={name}
        />
        <label></label>
    </div>
  )
}

export default CheckboxV2